import SectionHeading from "./SectionHeading";

const STATS = [
  { num: "1286万", label: "入驻瓜友" },
  { num: "3.6万+", label: "日均热议" },
  { num: "128", label: "活跃话题" },
  { num: "96%", label: "好评率" },
];

const PRINCIPLES = [
  { icon: "ri-search-eye-line", title: "吃瓜有度，真相第一", desc: "先核实再围观，不传谣不信谣，让每一次热议都建立在事实之上。" },
  { icon: "ri-message-3-line", title: "理性发言，换位思考", desc: "可以有不同的声音，但请以尊重为前提，站在对方的角度看问题。" },
  { icon: "ri-heart-line", title: "拒绝网暴，拒绝戾气", desc: "把瓜吃出快乐，而不是恶意。伤害他人的言论在这里一律不受欢迎。" },
  { icon: "ri-emotion-laugh-line", title: "快乐分享，一起围观", desc: "好的话题要一起聊，有趣的梗要一起接，吃瓜的快乐在于有人陪伴。" },
];

const REVIEWS = [
  { char: "新", tone: "bg-primary-100", name: "新晋吃瓜人", text: "工作之余最好的消遣，讨论氛围很轻松，从来没见过谁真的吵起来，这点很难得。" },
  { char: "沉", tone: "bg-accent-100", name: "熬夜看神评的社畜", text: "神评含量太高了，每次都能笑到打鸣，已经习惯每天睡前刷一遍评论区。" },
  { char: "安", tone: "bg-secondary-100", name: "理性发言爱好者", text: "最喜欢这里理性又不失趣味的分寸感，希望一直保持下去，做一个合格的瓜友。" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="瓜田学堂 · 关于吾爱吃瓜"
          title="一个让网友安心"
          accent="快乐吃瓜的地方"
          desc="吾爱吃瓜是汇聚全网网友评论与热议话题的围观社区。我们相信，好的讨论能带来共鸣，也能让人与人之间的距离更近。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
          <div className="rounded-2xl bg-gradient-to-br from-background-100 to-background-200/70 p-6 md:p-7 ring-1 ring-background-200/60">
            <div className="flex items-center gap-3">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-500 text-2xl shadow-sm">🍉</span>
              <div>
                <h3 className="font-heading text-xl text-foreground-950">我们的吃瓜守则</h3>
                <p className="text-sm text-foreground-500">快乐吃瓜，也要理性吃瓜</p>
              </div>
            </div>

            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {PRINCIPLES.map((p) => (
                <li key={p.title} className="flex items-start gap-3 rounded-xl bg-background-50 p-4 ring-1 ring-background-200/60">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={p.icon}></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900">{p.title}</h4>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-5">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {STATS.map((s) => (
                <div key={s.label} className="rounded-2xl bg-accent-100/70 p-4 text-center">
                  <p className="font-heading text-2xl text-foreground-950">{s.num}</p>
                  <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>

            <div className="rounded-2xl bg-background-100/80 p-5 ring-1 ring-background-200/60">
              <h3 className="text-base font-semibold text-foreground-900">
                <i className="ri-user-heart-line mr-1.5 text-primary-600"></i>
                瓜友们怎么说
              </h3>
              <div className="mt-4 grid grid-cols-1 gap-3">
                {REVIEWS.map((r) => (
                  <div key={r.name} className="flex items-start gap-3 rounded-xl bg-background-50 p-3.5 ring-1 ring-background-200/60">
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${r.tone} text-sm font-semibold text-foreground-700`}>
                      {r.char}
                    </span>
                    <div>
                      <p className="text-[13px] leading-relaxed text-foreground-700">“{r.text}”</p>
                      <p className="mt-1.5 text-xs text-foreground-500">—— {r.name}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}